<template>
  <div class="quiz-body">
    <template v-if="passed">
      <div class="col-left">
        <h1>Level {{$route.params.level - 1 }} completed!</h1>
        <p>Congratulations!
          <br>You answered {{answered}} questions correctly
          <template v-if="earned">, earned {{earned}} points,</template>
          <template v-if="!lastLevel"> and unlocked level {{$route.params.level}}</template>.</p>
        <div class="buttons">
          <router-link class="button--submit" v-if="lastLevel" :to="`/${$route.params.companySlug}/quizzes/${$route.params.id}/end`">Finish</router-link>
          <router-link class="button--submit" v-else :to="`/${$route.params.companySlug}/quizzes/${$route.params.id}/next/${$route.params.level}`">Let’s play next level</router-link>
          <router-link v-if="!lastLevel" class="button" :to="`/${$route.params.companySlug}/quizzes`">Finish for now, I will play the next level later</router-link>
        </div>
      </div>
      <img src="/web/quiz_level_completed.svg">
    </template>
    <template v-else>
      <div class="col-left">
        <h1>Level {{ prevLevel }} failed!</h1>
        <p>You answered {{answered}} questions correctly.
          <template v-if="earned">, earned {{earned}} points.</template>
          Try again?</p>
        <div class="buttons">
          <router-link :to="`${$route.params.companySlug}/quizzes/${$route.params.id}/next/${$route.params.level - 1}`" class="button--submit">Try again</router-link>
          <router-link class="button" :to="`/${$route.params.companySlug}/quizzes`">Finish for now, I will play later</router-link>
        </div>
      </div>
     <img src="/web/quiz_level_failed.svg">
    </template>
  </div>
</template>

<script>
import api from '@/api/quiz'
export default {
  name: "QuizLevelEnd",
  data () {
    return {
      earned: 0
    }
  },
  mounted() {
    let payload = {
      idQuiz: this.quiz.idQuiz,
      answers: []
    }
    this.questionsFromThisPrevLevel.forEach(question => {
      payload.answers.push({
        ...this.$store.getters.quizAnswers[question.idQuizQuestion],
        level : this.prevLevel,
        idQuizQuestion : question.idQuizQuestion
      })
    })
    api.submitQuiz(payload, (response) => {
      this.earned = response.pointslevel
    })
  },
  computed: {
    quiz() {
      return this.$store.getters.quiz
    },
    prevLevel() {
      return this.$route.params.level - 1
    },
    questionsFromThisPrevLevel() {
      return this.quiz._embedded.Questions.filter(question => {
        return question.level === this.prevLevel
      })
    },
    answered() {
      let count = 0;
      this.questionsFromThisPrevLevel.forEach(question => {
        if(this.$store.getters.quizAnswers[question.idQuizQuestion] && this.$store.getters.quizAnswers[question.idQuizQuestion].isCorrect) {
          count++
        }
      })
      return count
    },
    lastLevel() {
      return this.quiz.correctAnswersToPassLevel.length === this.prevLevel
    },
    passed() {
      return this.quiz.correctAnswersToPassLevel[this.prevLevel - 1] <= this.answered
    }
  }
}
</script>
